import React from 'react';
import { API_URL } from "../../../constants/config";

const CourseQandA = ({ 
  className = "", 
  courseId,
  showQA
}) => {
  const iframeURL = `${API_URL}forum_service/${courseId}/0/main`;  

  return (
    <>
    {showQA && 
    <div className={`${className} myk__stu-courses-qna-wrapper w-100`}>
      <div className="myk__stu-course-qna_filter">
        <iframe src={iframeURL} frameBorder="0" height="100%" width="100%" style={{ width: '100%', height: 'calc(100vh - 95px)' }}></iframe>
      </div>
    </div>
    }
    </>
  );
};

export default CourseQandA;
